import React from 'react'
import { FaFacebook, FaInstagram, FaLinkedin, FaGithubSquare} from 'react-icons/fa'
import { DiHtml5, DiCss3, DiJsBadge, DiNodejsSmall, DiMongodb, DiReact, DiPython, DiGit, DiRedis } from 'react-icons/di'

import Photo from '../static/parag_mahale_img.jpg'

const about = () => {
    return (
        <section className="h-auto lg:h-screen mx-10">

            <h2 className="text-5xl font-semibold font-quicksand mb-20 text-center text-primary"> <span className="canvas-hover p-2"> About me </span> </h2>

            <div id="about">
                <div className="grid grid-rows-2 grid-cols-1 md:grid-rows-1 md:grid-cols-2 gap-3">
                    <div className="justify-self-center">
                        <img src={Photo} alt="" className="w-40 rounded-full"/>
                        <br />
                        <span className="text-3xl flex flex-row justify-evenly">
                            <a className="inline-block canvas-hover p-2" href='https://www.facebook.com/parag.mahale/' style={{cursor: 'none'}}> <FaFacebook /> </a>
                            <a className="inline-block canvas-hover p-2" href='https://www.instagram.com/s0npari11/' style={{cursor: 'none'}}> <FaInstagram /> </a> 
                            <a className="inline-block canvas-hover p-2" href='https://www.linkedin.com/in/parag-mahale/' style={{cursor: 'none'}}> <FaLinkedin /> </a> 
                            <a className="inline-block canvas-hover p-2" href='https://github.com/S0npaRi11' style={{cursor: 'none'}}> <FaGithubSquare /> </a>
                        </span>
                    </div>
                    <div>
                       <p className="font-quicksand text-md pt-5 md:pt-0 md:text-xl">
                            Hi, my name is Parag Mahale, a software engineer and full stack web developer.
                            I create websites as a hobby and as a part-time job.
                            I enjoy designing and developing websites.
                            <br /> <br />
                            For me, programming is about challenging myself everyday to better myself, 
                            while doing the job that I enjoy.
                            <br /> <br />
                            The joy and satisfaction after figuring out a difficult problem or completing a project,
                            that is the feeling I am working for.
                       </p>
                    </div>
                </div>

                <h2 className="text-5xl font-semibold font-quicksand my-20 text-center text-primary"> <span className="canvas-hover p-2"> Skills </span>  </h2>

                <span className="flex flex-row flex-wrap justify-evenly text-4xl">
                    <span className="p-2 canvas-hover"> <DiHtml5 /> </span> 
                    <span className="p-2 canvas-hover"> <DiCss3 /> </span> 
                    <span className="p-2 canvas-hover"> <DiJsBadge /> </span>
                    <span className="p-2 canvas-hover"> <DiNodejsSmall /> </span>
                    <span className="p-2 canvas-hover"> <DiReact /> </span>
                    <span className="p-2 canvas-hover"> <DiMongodb /> </span>
                    <span className="p-2 canvas-hover"> <DiGit /> </span>
                    <span className="p-2 canvas-hover"> <DiRedis /> </span>
                    <span className="p-2 canvas-hover"> <DiPython /> </span>
                </span>
            </div>
        </section>
    )
}

export default about
